<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 250px">
        <p>对账单编号：</p>
        <el-input v-model="numIpt" size="mini" style="width: 140px" placeholder="请输入对账单编号" />
      </div>
      <div class="navContainer">
        <p>标题：</p>
        <el-input v-model="titleIpt" size="mini" style="width: 140px" placeholder="请输入标题" />
      </div>
      <!--      <div class='navContainer' style='width: 240px'>-->
      <!--        <p>环节：</p>-->
      <!--        <el-select v-model='type' filterable size='mini' style='width:150px'-->
      <!--                   placeholder='请选择环节'>-->
      <!--          <el-option v-for='item in typeOption' :key='item.label' :label='item.label'-->
      <!--                     :value='item.value'/>-->
      <!--        </el-select>-->
      <!--      </div>-->
      <div class="navContainer" style="width: 240px">
        <p>结算方式：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width: 150px" placeholder="请选择结算方式">
          <el-option v-for="item in typeIptOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 240px">
        <p>供应商：</p>
        <el-input v-model="entrustIpt" size="mini" style="width: 140px" placeholder="请输入供应商" />
      </div>
      <div class="navContainer" style="width: 420px">
        <p style="display: inline-block; width: 120px; text-align: center">对账单生成时间：</p>
        <el-date-picker v-model="timeIpt[0]" size="mini" style="width: 140px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期" />
        <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-model="timeIpt[1]" size="mini" style="width: 140px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期" />
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width: 140px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 210px">
        <p style="width: 90px">对账人员：</p>
        <el-input v-model="reconciliator" size="mini" style="width: 150px" placeholder="请输入对账人员" />
      </div>
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input v-model="consignor" size="mini" style="width: 140px" placeholder="请输入委托商" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span style="color: red;">{{ msg }}</span>
        <span @click="exportData">详情批量导出</span>
        <span @click="exportDatas">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table v-loading="tableLoad" :data="TableDatas" style="width: 100%" max-height="600px" ref="listTable" border
                  :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '48px', background: '#E8E8E8' }"
                  :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
                  :expand-row-keys="expands" @selection-change="selectionDataChange" :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="50px" />
          <el-table-column prop="settNo" label="对账单编号" align="center" min-width="100" />
          <el-table-column prop="title" width="150" label="标题" align="center" />
          <!--          <el-table-column prop='type' label='环节' width='130' align='center'>-->
          <!--            <template slot-scope='scope'>{{ scope.row.type | typeFormat }}</template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="settType" label="结算方式" align="center" width="120px">
            <template slot-scope="scope">{{ scope.row.settType | settTypeFormat }}</template>
          </el-table-column>
          <el-table-column label="供应商" align="center" show-overflow-tooltip width="140">
            <div slot-scope="scope">
              {{ scope.row.companyNameNew }}
              <!--  判断与 原供应商 是否相同  相同不显示 -->
              <el-tooltip v-if="scope.row.companyNameNew !== scope.row.companyNameOld" :content="`原供应商：${scope.row.companyNameOld}`" placement="bottom" effect="light">
                <img v-if="scope.row.companyNameOld" alt="" :src="require('@/assets/images/warnning.png')" />
              </el-tooltip>
            </div>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.taxRate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="taxPrice" label="差价" align="center" width="90px" />
          <el-table-column prop="settINum" label="结算数量" width="140" align="center" show-overflow-tooltip />
          <el-table-column prop="settlementPrice" label="合同价" align="center" width="90px" />
          <el-table-column prop="taxSettPrice" label="预结算价" align="center" width="90px" />
          <el-table-column prop="otherPrice" label="其他费用" align="center" width="90px" />
          <!-- <el-table-column label="发票号" align="center" width="150" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span> {{ getInvoiceNo(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发票时间" align="center" width="150" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>{{ getInvoiceCreateTime(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发票金额" align="center" width="150" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>{{ getInvoicePrice(scope.row) }} </span>
            </template>
          </el-table-column>
          <el-table-column label="发票税率" prop="invoiceTaxRate" align="center" width="150" show-overflow-tooltip></el-table-column> -->
          <el-table-column label="发票号" prop="invoiceNo" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票时间" prop="invoiceDate" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票金额" prop="invoicePrice" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票税率" prop="invoiceTaxRate" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票代码" prop="invoiceCode" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="对账单生成时间" align="center" min-width="100" />
          <el-table-column prop="status" label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="推送状态" width="140" align="center" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>{{ scope.row.isSend==1?'已推送':'未推送' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reconciliator" label="对账人员" width="140" align="center" show-overflow-tooltip />
          <el-table-column prop="consignor" label="委托商" align="center" show-overflow-tooltip width="140" />
          <el-table-column prop="remark" label="备注" width="140" align="center" show-overflow-tooltip />

          <!--          <el-table-column prop='operateRecord.operationName' label='操作人' width='140' align='center' show-overflow-tooltip fixed="right" />-->
          <el-table-column label="操作" width="425" align="center" fixed="right">
            <!-- childrenType 100：子数据 0：父数据-->
            <template slot-scope="scope">
              <div>
                <div class="fatherTable">
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1" size="mini" class="searchBtn btnTopBottom10" type="primary" @click="changeClick(scope.row.id)">核对对账单 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1" size="mini" class="searchBtn btnTopBottom10" type="primary" @click="detailClick(scope.row.id)" style="margin-bottom: 10px;">详情 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1" size="mini" type="primary" @click="auditClick(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">提交审核 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 1" size="mini" type="danger" @click="disableClick(scope.row.id)" class="btnTopBottom10">取消审核 </el-button>
                  <!--                 <el-button v-if='scope.row.status === 1' size='mini' class='yellow-bg' type='primary'>
                                     添加对账单
                                   </el-button>-->
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 3" size="mini" type="primary" @click="invoiceClick(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">寄送发票 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 5" size="mini" type="primary" @click="invoiceReceived(scope.row)" class="btnTopBottom10">确认收票 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 5" size="mini" type="danger" @click="invoiceReturn(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">退回 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 5" size="mini" class="yellow-bg btnTopBottom10" type="primary" @click="collectionClick(scope.row.id)">催收开票 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1" size="mini" type="info" @click="deleteClick(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">删除 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 2" size="mini" type="primary" @click="fillInInvoice(scope.row.id, scope.row.reconciliator, scope.row)" class="btnTopBottom10">填写发票 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0" size="mini" type="primary" @click="titleChange(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">更改标题 </el-button>
                  <el-button v-if="scope.row.isHongchong != 1" size="mini" type="primary" @click="editRemark(scope.row)" class="btnTopBottom10">修改备注</el-button>
                  <el-button v-if="scope.row.isHongchong != 1" size="mini" type="danger" @click="hongChong(scope.row)" class="btnTopBottom10">红冲</el-button>
                  <el-button v-if=' scope.row.status >= 2 ' size='mini' type='primary' @click='dataPush(scope.row.id,scope.row.reconciliator,scope) '>推送</el-button>
                  <el-button v-if="scope.row.isHongchong != 1 && scope.row.isSend == 1" size="mini" type="primary" @click="onClickVoid(scope.row)" class="btnTopBottom10">作废</el-button>
                  <!--                  <el-button v-if=' scope.row.isSend === 1 ' size='mini' type='primary'-->
                  <!--                             @click='cancelPush(scope.row.id) '>取消推送-->
                  <!--                  </el-button>-->
                  <!--                  <el-button v-if='scope.row.status === 2' size='mini' type='primary'-->
                  <!--                             @click='addContractPrice(scope.row.id)'>添加合同价-->
                  <!--                  </el-button>-->
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[50, 100, 200]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" :width="detailDialogWidth" @close="detailClose" center top="10vh">
      <div class="detail">
        <el-tabs v-model="infoActiveName">
          <el-tab-pane label="基础信息" name="first">
            <div class="baseInfo">
              <div class="baseInfoContent">
                <div class="baseInfoContentItem">
                  <span class="span1">对账单编号：</span>
                  <span>{{ detailData.settNo }}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">标题：</span>
                  <span>{{ detailData.title }}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">供应商：</span>
                  <span>{{ detailData.companyNameNew }}</span>
                  <el-tooltip v-if="detailData.companyNameOld !== detailData.companyNameNew" placement="bottom" effect="light">
                    <div slot="content">
                      <span style="color: #999">原供应商：{{ detailData.companyNameOld }}</span>
                    </div>
                    <i class="el-icon-warning" style="color: red; font-size: 18px; margin-right: 5px" />
                  </el-tooltip>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne" style="width: 250px">
                    <span class="span1">差价：</span>
                    <span>{{ detailData.taxPrice || 0 }}元</span>
                  </div>
                  <div style="width: 250px">
                    <span class="span1">合同价：</span>
                    <span>{{ detailData.settlementPrice || 0 }}元</span>
                  </div>
                  <div style="width: 250px">
                    <span class="span1">预结算价：</span>
                    <span>{{ detailData.taxSettPrice || 0 }}元</span>
                  </div>
                </div>
                <!--                <div class='baseInfoContentItem specialItem'>
                                  <div class='specialOne'>
                                    <span class='span1'>实际含税费用：</span>
                                    <span>{{ detailData.taxPrice || 0 }}元</span>
                                    <el-tooltip placement='bottom' effect='light'>
                                      <div slot='content'>
                                        <span style='color: #999;'>基础托运费用{{ detailData.price || 0 }}元</span><br />
                                        <span style='color: #999;'>基础其它费用{{ detailData.price || 0 }}元</span><br />
                                        <span
                                          style='color: #FF3A30'>抵扣超出合同价对账单{{ detailData.price || 0 }}元</span><br />
                                        <span style='color: #FF3A30'>暂缓开票{{ detailData.price || 0 }}元</span><br />
                                      </div>
                                      <i class='el-icon-warning'
                                         style='color: red;font-size: 18px;margin-right: 5px;' />
                                    </el-tooltip>
                                  </div>
                                  <div>
                                    <span class='span1'>实际不含税费用：</span>
                                    <span>{{ detailData.noTaxPrice || 0 }}元</span>
                                  </div>
                                </div>-->
                <div class="baseInfoContentItem">
                  <span class="span1">生成对账单时间：</span>
                  <span>{{ detailData.createTime }}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">台账月汇总金额：</span>
                  <span>{{ detailData.statistics }}</span>
                </div>
              </div>
            </div>
            <div class="operation" v-if="detailData.isDeduct == 1">
              <div class="operationTitle">
                <div class="line" />
                <span>抵扣对账单</span>
              </div>
              <div class="operationTable">
                <el-table :data="detailData.table1" border>
                  <el-table-column label="序号" align="center" type="index" />
                  <el-table-column prop="operateType" label="对账单编号" align="center" />
                  <el-table-column prop="operationName" label="抵扣费用" align="center" />
                </el-table>
              </div>
            </div>
            <div class="baseInfo" v-if="detailData.status == 1">
              <div class="baseInfoTitle">
                <div class="line" />
                <span>审核信息</span>
              </div>
              <div style="width: 70%">
                <steps :step-data="stepData" :step-state="stepState" />
              </div>
            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line" />
                <span>操作记录</span>
              </div>
              <div class="operationTable">
                <el-table :data="detailData.operateRecordList" border>
                  <el-table-column label="操作时间" align="center" width="160px">
                    <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
                  </el-table-column>
                  <el-table-column prop="operateType" label="操作类型" align="center" />
                  <el-table-column prop="operationName" label="操作人" align="center" />
                  <el-table-column prop="remark" label="备注" align="center" />
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="结算费用" name="second">
            <div class="baseInfo">
              <!--              <div class='baseInfoContent' style='padding: 0'>
                              <div class='baseInfoContentItem specialItem'>
                                <div class='specialOne'>
                                  <span class='span1'>合计含税结算金额：</span>
                                  <span>{{ sumCost(detailData.supplierPortOperationInfos, 'taxContractPrice')
                                    }}</span>
                                </div>
                                <div>
                                  <span class='span1'>合计不含税结算金额：</span>
                                  <span>{{ sumCost(detailData.supplierPortOperationInfos, 'contractPrice')
                                    }}</span>
                                </div>
                              </div>
                            </div>-->
              <div class="operationTable" style="margin-top: 0">
                <!--                <div class='operationTableNav'>
                                  <span>导出数据</span>
                                </div>-->
                <el-table :data="detailTable1" v-loading="detailTable1Loading" border script>
                  <el-table-column prop="supplierName" label="供应商" align="center" width="150" show-overflow-tooltip />
                  <el-table-column prop="batchNumber" label="批次号" align="center" width="150" show-overflow-tooltip />
                  <el-table-column prop="waybillNo" label="运单编号" align="center" width="150" show-overflow-tooltip />
                  <el-table-column prop="frameNumber" label="车架号" align="center" width="150" show-overflow-tooltip />
                  <el-table-column prop="workType" label="作业类型" align="center" width="80px">
                    <template slot-scope="scope">{{ scope.row.workType | workTypeFormat }}</template>
                  </el-table-column>
                  <el-table-column prop="standingBookMonth" label="台账月" align="center" width="100" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="taxRate" label="税率(%)" align="center" />
                  <el-table-column prop="taxContractPrice" label="含税合同价" align="center" />
                  <el-table-column prop="taxPreparePrice" label="含税预结算价" align="center" />
                  <el-table-column prop="difPrice" label="差价" align="center" width="90px" />
                </el-table>
              </div>
              <div class="paginationContainer" style="display: flex; align-items: center; padding: 10px 20px">
                <span>共{{ detailTable1Total }}条</span>
                <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="detailTable1Total" @size-change="detailSizeChange" @current-change="detailCurrentChange" @prev-click="detailCurrentChange" @next-click="detailCurrentChange" />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="其它结算费用" name="third">
            <div class="baseInfo">
              <!--              <div class='baseInfoContent' style='padding: 0'>
                              <div class='baseInfoContentItem specialItem'>
                                <div class='specialOne'>
                                  <span class='span1'>合计含税结算金额：</span>
                                  <span>{{ sumCost(detailData.costInfos, 'costAmount') }}</span>
                                </div>
                                <div>
                                  <span class='span1'>合计不含税结算金额：</span>
                                  <span>{{ sumCost(detailData.costInfos, 'excludingTaxAmount') }}</span>
                                </div>
                              </div>
                            </div>-->
              <div class="operationTable" style="margin-top: 0">
                <el-table :data="detailTable2" v-loading="detailTable2Loading" border script>
                  <el-table-column label="序号" align="center" type="index" />
                  <el-table-column prop="costNum" label="费用编号" align="center" />
                  <el-table-column prop="costTypeName" label="费用类型" align="center" />
                  <el-table-column prop="costInstruction" label="费用说明" align="center" />
                  <el-table-column prop="costTime" label="费用时间" align="center">
                    <template slot-scope="scope">{{ scope.row.costTime | formatTime }}</template>
                  </el-table-column>
                  <el-table-column prop="taxRate" label="税率(%)" align="center" />
                  <el-table-column prop="costAmount" label="含税价" align="center" />
                  <el-table-column prop="excludingTaxAmount" label="不含税价" align="center" />
                  <el-table-column prop="remark" label="说明" align="center" />
                </el-table>
              </div>
              <div class="paginationContainer" style="display: flex; align-items: center; padding: 10px 20px">
                <span>共{{ detailTable2Total }}条</span>
                <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="detailTable2Total" @size-change="detail2SizeChange" @current-change="detail2CurrentChange" @prev-click="detail2CurrentChange" @next-click="detail2CurrentChange" />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="开票信息" name="fourth" v-if="detailData.status != 0 && detailData.status != 1">
            <div class="baseInfo">
              <div class="baseInfoContent" style="padding: 0">
                <!--                <div class='baseInfoContentItem'>
                                  <span class='span1'>是否抵扣开票：</span>
                                  <span>{{ detailData.time2 }}</span>
                                </div>
                                <div class='baseInfoContentItem'>
                                  <span class='span1'>抵扣开票费用编号：</span>
                                  <span>{{ detailData.time2 }}</span>
                                </div>
                                <div class='baseInfoContentItem'>
                                  <span class='span1'>确认收到发票时间：</span>
                                  <span>{{ detailData.time2 }}</span>
                                </div>
                                <div class='baseInfoContentItem'>
                                  <div class='imgContainer'>
                                    <el-image
                                      v-for='(item,index) in detailData.img'
                                      :key='index'
                                      style='width: 100px; height: 100px;margin-right:10px; '
                                      :src='baseImgUrl + item'
                                      :preview-src-list='[baseImgUrl + item]'
                                      fit='cover'
                                    />
                                  </div>
                                </div>
                                <div class='baseInfoContentItem specialItem'>
                                  <div class='specialOne'>
                                    <span class='span1'>原开票金额：</span>
                                    <span>{{ detailData.customerNatureName }}</span>
                                  </div>
                                  <div>
                                    <span class='span1'>抵扣金额：</span>
                                    <span>{{ detailData.customerScaleName }}</span>
                                  </div>
                                  <div>
                                    <span class='span1'>实际开票金额：</span>
                                    <span>{{ detailData.customerScaleName }}</span>
                                  </div>
                                </div>-->
              </div>
              <div class="operationTable" style="margin-top: 0">
                <el-table :data="infoInvoice" border script>
                  <el-table-column label="序号" align="center" type="index" />
                  <el-table-column prop="invoiceNo" label="发票号码" align="center" />
                  <el-table-column prop="invoiceCode" label="发票代码" align="center" />
                  <el-table-column prop="invoicDate" label="发票日期" align="center" />
                  <el-table-column prop="taxPrice" label="含税金额" align="center" />
                  <el-table-column prop="price" label="不含税金额" align="center" />
                  <el-table-column prop="taxRate" label="税率" align="center" />
                  <el-table-column label="开票类型" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.invoiceType ? '补开票' : '正常开票' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注" align="center" />
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!-- 核对对账单 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1200px" center @close="dialogClose" :close-on-click-modal="false">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">港口名称：</span>
              <span>{{ companyData.companyNameNew }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">标题：</span>
              <span>{{ companyData.title }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">合计含税费用：</span>
                <span>{{ companyData.settType === 1 ? companyData.taxPrice : companyData.taxSettPrice || 0 }}元</span>
              </div>
              <div>
                <span class="span1">合计不含税费用：</span>
                <span>{{ companyData.settType === 1 ? companyData.noTaxPrice : companyData.noTaxSettPrice || 0 }}元</span>
              </div>
            </div>
            <el-tabs v-model="activeName">
              <el-tab-pane label="操作费用核对" name="first">
                <!--                <div class='baseInfoContentItem'>
                                  <span class='span1'>结算方式：</span>
                                  <span>{{ companyData.name }}</span>
                                </div>-->
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">托运费合计含税费用：</span>
                    <span>{{ companyData.settlementPrice }}元</span>
                  </div>
                  <div>
                    <span class="span1">托运费合计不含税费用：</span>
                    <span>{{ settlementPriceCalculation }}元</span>
                  </div>
                </div>
                <div class="baseInfoContentItem" style="display: flex">
                  <span class="span1">上传时间：</span>
                  <span>{{ companyData.time }}</span>
                  <span class="spanStyle" @click="download">下载</span>
                  <span class="spanStyle">
                    <el-upload ref="upload" class="upload-demo" :disabled="uploadDis1" :action="uploadUrl1" :auto-upload="true" :show-file-list="false" :data="uploadData1" :http-request="uploadHttp" :on-success="planOnSuccess" :before-upload="beforeUpload">重新上传 </el-upload>
                  </span>
                </div>
              </el-tab-pane>
              <el-tab-pane label="其它费用核对" name="second">
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">其它费合计含税费用：</span>
                    <span>{{ companyData.otherPrice || 0 }}元</span>
                  </div>
                  <div>
                    <span class="span1">其它费合计不含税费用：</span>
                    <span> {{ Number(sumCost(tableData2, 'excludingTaxAmount')).toFixed(2) }}元 </span>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>{{ activeName === 'first' ? '异常数据' : '已选择其它费用' }}</span>
            </div>
            <div class="operationTable" v-if="activeName === 'first'">
              <el-table :data="tableData1" v-loading="tableLoad1" :row-class-name="tableRowClassName" border script>
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column prop="waybillNo" label="运单编号" align="center" show-overflow-tooltip />
                <el-table-column prop="frameNumber" label="车架号" align="center" show-overflow-tooltip />
                <el-table-column prop="taxRate" label="税率(%)" align="center" />
                <el-table-column prop="taxPrice" label="含税单价" align="center" />
                <el-table-column prop="neTaxPrice" label="不含税单价" align="center" />
                <el-table-column prop="remark" label="说明" align="center" show-overflow-tooltip />
                <el-table-column label="操作" align="center" width="170">
                  <template slot-scope="scope">
                    <div v-if="scope.row.type !== 1" style="display: flex; align-items: center; justify-content: center; padding-left: 5px">
                      <el-button size="mini" type="primary" @click="changePriceClick(scope.$index, scope.row)">修改金额 </el-button>
                      <el-button size="mini" type="danger" @click="removeClick(scope.$index, scope.row, 0)"> 删除 </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="operationTable" v-else>
              <div class="operationTableNav">
                <span @click="exportClick">添加</span>
              </div>
              <el-table :data="tableData2" :row-class-name="tableRowClassName" border script>
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column prop="costNum" label="费用编号" align="center" />
                <el-table-column prop="costTypeName" label="费用类型" align="center" />
                <el-table-column prop="costInstruction" label="费用说明" align="center" />
                <el-table-column prop="costTime" label="费用时间" align="center">
                  <template slot-scope="scope">{{ scope.row.costTime | formatTime }}</template>
                </el-table-column>
                <el-table-column prop="taxRate" label="税率(%)" align="center" />
                <el-table-column prop="costAmount" label="含税价" align="center" />
                <el-table-column prop="excludingTaxAmount" label="不含税价" align="center" />
                <el-table-column prop="remark" label="说明" align="center" />
                <el-table-column label="操作" align="center" width="50px">
                  <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center" v-if="tableData2.length > 0">
                    <img alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index, scope.row, 1)" />
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!--          <div class='operation'>
                      <div class='operationTitle'>
                        <div class='line' />
                        <span>{{ activeName === 'first' ? '未选择运单' : '未选择其它费用' }}</span>
                      </div>
                      <div class='operationTable' v-if="activeName === 'first'">
                        <el-table
                          :data='tableData3'
                          :row-class-name='tableRowClassName'
                          border
                          script
                        >
                          <el-table-column label='序号' align='center' type='index' />
                          <el-table-column prop='workNumber' label='作业编号' align='center' />
                          <el-table-column prop='portName' label='作业港口' align='center' />
                          <el-table-column prop='workType' label='作业类型' align='center'>
                            <template slot-scope='scope'>{{ scope.row.workType |workTypeFormat }}</template>
                          </el-table-column>
                          <el-table-column prop='batchNumber' label='批次号' align='center' />
                          <el-table-column prop='chassisNumber' label='底盘号' align='center' />
                          <el-table-column prop='brandName' label='品牌' align='center' />
                          <el-table-column prop='modelName' label='型号' align='center' />
                          <el-table-column prop='taxRate' label='税率(%)' align='center' />
                          <el-table-column prop='taxPrice' label='含税单价' align='center' />
                          <el-table-column prop='price' label='不含税单价' align='center' />
                          <el-table-column prop='remark' label='说明' align='center' />
                          <el-table-column label='操作' align='center' width='170'>
                            <template slot-scope='scope'>
                              <div style='display:flex;align-items:center;padding-left: 10px'>
                                <el-button size='mini' type='primary' @click='addTableClick(scope.$index, 0)'>
                                  添加
                                </el-button>
                                <el-button size='mini' type='primary'>首页提醒</el-button>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <div class='operationTable' v-else>
                        <el-table
                          :data='tableData4'
                          :row-class-name='tableRowClassName'
                          border
                          script
                        >
                          <el-table-column label='序号' align='center' type='index' />
                          <el-table-column prop='costNum' label='费用编号' align='center' />
                          <el-table-column prop='costTypeName' label='费用类型' align='center' />
                          <el-table-column prop='costInstruction' label='费用说明' align='center' />
                          <el-table-column prop='costTime' label='费用时间' align='center'>
                            <template slot-scope='scope'>{{ scope.row.costTime |formatTime }}</template>
                          </el-table-column>
                          <el-table-column prop='taxRate' label='税率(%)' align='center' />
                          <el-table-column prop='costAmount' label='含税价' align='center' />
                          <el-table-column prop='excludingTaxAmount' label='不含税价' align='center' />
                          <el-table-column prop='remark' label='说明' align='center' />
                          <el-table-column label='操作' align='center' width='75'>
                            <template slot-scope='scope'>
                              <div style='display:flex;align-items:center;padding-left: 10px'>
                                <el-button size='mini' type='primary' @click='addTableClick(scope.$index, 1)'>
                                  添加
                                </el-button>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>-->
        </div>
      </div>
    </el-dialog>
    <el-dialog title="选择适配车型" :visible.sync="carVisible" width="600px" @close="carClose" center :close-on-click-modal="false" top="20vh">
      <div class="carContainer">
        <div class="carContainerTitle">
          <span>已选择车型：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectCar" @click="selectRemove(item)">{{ item.name }}<i class="el-icon-close" /></div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择品牌：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectBrand">
              <p @click="brandClick(item.id)">{{ item.name }}&nbsp;</p>
              <i class="el-icon-plus" @click="brandAdd(item)" />
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择型号：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectModel" @click="modelAdd(item)">
              <p>{{ item.name }}</p>
              <i class="el-icon-plus" />
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="mini" @click="carAddClick">确定</el-button>
          <el-button class="resetBtn" size="mini" @click="carClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="添加其它费用" :visible.sync="addVisible" width="1000px" center :close-on-click-modal="false" top="20vh">
      <!-- otherDataCelect  多选表格触发联动  otherDateProps 传递已有数据用以回显   consignor-id 供应商，公司id 分页查询用 -->
      <accounts-other-add ref="otherAdds" @closeDialog="addClose" @addOther="getOtherData" :account-id="basicId" :consignor-id="companyData.companyId" />
    </el-dialog>
    <el-dialog title="提交审核" :visible.sync="auditVisible" width="600px" @close="auditClose" center :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="auditData" label-width="120px" :rules="rules2" ref="ruleForm2" size="medium">
          <div-border label="超出合同价" divStyle="margin-top: 10px;padding-top:15px;">
            <span style="color: #ff3a30; margin-left: 10px">发现当前委托商有往期超出合同价未结算完！</span>
            <el-form-item label="是否抵扣超出合同价：" prop="deduction" label-width="160px">
              <el-radio v-model="auditData.deduction" :label="1">否</el-radio>
              <el-radio v-model="auditData.deduction" :label="0">是</el-radio>
            </el-form-item>
            <el-form-item v-if="auditData.deduction === 0" label="最多可抵扣费用：" style="margin-bottom: 0"> {{ auditData.maxPrice }}元 </el-form-item>
            <div class="departTable" v-if="auditData.deduction === 0">
              <el-table border :data="auditData.table">
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column label="对账单编号" align="center">
                  <template slot-scope="scope">
                    <el-select filterable v-model="auditData.table[scope.$index].num" size="mini" style="width: 100%" placeholder="请选择对账单" @change="numChange(scope.$index)">
                      <el-option v-for="item in numOption" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="最大抵扣费用" align="center" prop="max" />
                <el-table-column label="抵扣费用" align="center" prop="price">
                  <template slot-scope="scope">
                    <el-input v-model="auditData.table[scope.$index].price" size="mini" style="width: 100%" placeholder="请输入抵扣费用" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
                    <img v-if="auditData.table.length !== 1" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="numRemoveClick(scope.$index)" />
                  </div>
                </el-table-column>
              </el-table>
              <div class="tableAddBtnContainer">
                <div class="AddContainer" @click="addCl">
                  <img alt="" :src="require('@/assets/images/u131.png')" />
                  <p>新增</p>
                </div>
              </div>
            </div>
          </div-border>
          <div-border label="开票选择" divStyle="margin-top: 10px;padding-top:15px;">
            <el-form-item label="开票总金额：" style="margin-bottom: 0"> {{ auditData.total }}元 </el-form-item>
            <div style="display: flex; align-items: center; height: 50px">
              <el-form-item label="是否暂缓开票：" style="margin-bottom: 5px" prop="invoice">
                <el-radio v-model="auditData.invoice" :label="1">否</el-radio>
                <el-radio v-model="auditData.invoice" :label="0">是</el-radio>
              </el-form-item>
              <el-form-item v-if="!auditData.invoice" prop="invoicePrice" class="specialItem" style="margin-left: 10px">
                <el-input type="number" v-if="!auditData.invoice" v-model="auditData.invoicePrice" size="mini" style="width: 100%" placeholder="请输入暂缓开票金额">
                  <span slot="suffix" style="color: #999">| 元</span>
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="开票方式：" prop="type">
              <el-radio v-model="auditData.type" :label="1">自动</el-radio>
              <el-radio v-model="auditData.type" :label="0">手动</el-radio>
            </el-form-item>
            <el-form-item label="预计开票数量：" style="margin-bottom: 18px">
              {{ auditData.table2.length }}
            </el-form-item>
            <div class="departTable" style="padding-left: 20%">
              <el-table border :data="auditData.table2">
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column label="开票金额" align="center" prop="price">
                  <template slot-scope="scope">
                    <el-input :disabled="auditData.type === 1" v-model="auditData.table2[scope.$index].price" size="mini" style="width: 100%" placeholder="请输入开票金额" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
                    <img v-if="auditData.table2.length !== 1 && auditData.type === 0" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="invoiceRemoveClick(scope.$index)" />
                  </div>
                </el-table-column>
              </el-table>
              <div class="tableAddBtnContainer" v-if="auditData.type !== 1">
                <div class="AddContainer" @click="addCl2">
                  <img alt="" :src="require('@/assets/images/u131.png')" />
                  <p>新增</p>
                </div>
              </div>
            </div>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" @click="auditConfirmClick">确定</el-button>
            <el-button size="medium" class="resetBtn" @click="auditClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="修改金额" :visible.sync="modifyAmountPortFlog" width="600px" center :close-on-click-modal="false" @close="modifyRemoveClick">
      <modifyAmountPort ref="modifyAmountPort" :type="'供应商港口对账单'">
        <!-- 插槽    提交按钮     -->
        <template slot-scope="scope" slot="confirmButton">
          <!--          {{scope.modigyData}}-->
          <el-button class="searchBtn" size="mini" @click="modifyconfirmClick(scope.modigyData)"> 确定 </el-button>
        </template>
        <!-- 插槽    取消按钮     -->
        <template slot="cancelButton">
          <el-button type="info" size="mini" @click="modifyRemoveClick">取消</el-button>
        </template>
      </modifyAmountPort>
    </el-dialog>
    <!-- 推送 -->
    <el-dialog title="选择推送" :visible.sync="dialogFormVisiblePush">
      <el-form :model="formPush" :inline="true">
        <el-form-item label="商品编号" label-width="120px">
          <el-select v-model="formPush.classbName" placeholder="请选择商品编号">
            <el-option :label="item.classaName" :value="item.classbName" v-for="(item, index) in productNumberOption" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票类型" label-width="120px">
          <el-select v-model="formPush.invoiceType" placeholder="请选择发票类型">
            <el-option :label="item.classaName" :value="item.classbName" v-for="(item, index) in invoiceTypeOption" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" label-width="120px">
          <el-input type="textarea" v-model="formPush.remarks" placeholder="请输入发票备注" style="width: 460px" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisiblePush = false">取 消</el-button>
        <el-button type="primary" :loading="pushLoading" @click="surePush">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 填写发票 -->
    <invoice-information ref="invoiceInformation" @getList="accountList" />
    <!-- 添加合同价 -->
    <add-contract-price ref="addContractPrice" @getList="accountList" />
    <!-- 寄送发票 -->
    <send-invoice ref="sendInvoiceRef" @success="accountList" />
    <!-- 退回 -->
    <statement-returned ref="statementReturnedRef" @success="accountList" />
  </div>
</template>

<script>
  import steps from '@/components/steps.vue';
  import modifyAmountPort from '@/views/settle/client/modifyAmountPort.vue';
  import accountsOtherAdd from '@/views/settle/supplier/components/accountsOtherAdd';
  import invoiceInformation from '@/components/invoiceInformation';
  import divBorder from '@/components/divBorder.vue';
  import { formatDateTime, formatTime, getSessionStore } from '@/config/mUtils';
  import { baseImgUrl, baseUrl } from '@/config/env';
  import { accountList, accountDetail, accountDelete, updateAndDeleteAmount, getPageListSCFI, getPageListSOCI, submitAuditInvoice, cancelApplyFor, getInfoInvoice, receiveInvoice, changeTitle, delOther, cancellation, dataPush, remarkSubmit, hongChong,repeal } from '@/service/getData';
  import $ from 'jquery';
  import { getImport } from '@/service/getIP';
  import AddContractPrice from '@/components/addContractPrice';
  import SendInvoice from '@/components/sendInvoice';
  import StatementReturned from '@/components/statementReturned';
  import {paramCategoryPageList} from "@/service/basicfile";

  export default {
    components: {
      StatementReturned,
      SendInvoice,
      AddContractPrice,
      steps,
      divBorder,
      modifyAmountPort,
      accountsOtherAdd,
      invoiceInformation,
    },
    data() {
      return {
        activeName: 'first',
        infoActiveName: 'first',
        entrustIpt: '',
        titleIpt: '',
        numIpt: '',
        type: '',
        typeIpt: '',
        stateIpt: '',
        reconciliator: '',
        consignor: '',
        timeIpt: ['', ''],
        productNumberOption: [],
        invoiceTypeOption: [],
        formPush: {
          classbName: '',
          invoiceType: '',
          remarks: ''
        },
        dialogFormVisiblePush: false,
        pushLoading: false,
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待提交审核',
          },
          {
            value: 1,
            label: '审核对账单中',
          },
          {
            value: 2,
            label: '系统开票中',
          },
          {
            value: 3,
            label: '填写快递单号',
          },
          {
            value: 4,
            label: '已收款',
          },
          {
            value: -1,
            label: '审核未通过',
          },
          {
            value: -2,
            label: '系统开票失败',
          },
          {
            value: -10,
            label: '已取消',
          },
        ],
        typeIptOption: [
          {
            label: '合同价',
            value: '1',
          },
          {
            label: '预结算价',
            value: '2',
          },
          {
            label: '合并价格',
            value: '3',
          },
        ],
        typeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '委托商运费',
          },
          {
            value: 2,
            label: '委托商港口费',
          },
          {
            value: 3,
            label: '暂无',
          },
          {
            value: 4,
            label: '公路供应商托运费',
          },
          {
            value: 5,
            label: '水路供应商运费',
          },
          {
            value: 6,
            label: '港口供应商操作费',
          },
          {
            value: 7,
            label: '港口供应商燃油费',
          },
          {
            value: 8,
            label: '港口堆存费',
          },
          {
            value: 9,
            label: '提车费',
          },
          {
            value: 13,
            label: '港口库房委托商结算',
          },
          {
            value: 14,
            label: '港口库房供应商结算(库房)',
          },
          {
            value: 15,
            label: '港口库房供应商结算(港口)',
          },
          {
            value: 17,
            label: '其他费用',
          },
        ],
        page: 1,
        size: 50,
        total: 0,
        tableLoad: false,
        msg: '',
        TableDatas: [],
        detailDialogVisible: false,
        detailDialogWidth: '1050px',
        detailTable: [],
        detailTable3: [{ price: 12 }],
        detailTable4: [{ price: 12 }],
        detailData: {
          table1: [],
          img: [],
        },
        baseImgUrl: `${baseImgUrl}/`,
        operationData: [],
        dialogVisible: false,
        dialogTitle: '',
        nameOption: [],
        payOption: [],
        addressOption: [],
        uploadData: {
          fileType: '1',
        },
        tableData1: [],
        tableData2: [],
        tableData3: [],
        tableData4: [],
        companyData: {},
        invoiceData: {
          img: [],
        },
        rules: {
          date: [
            {
              required: true,
              message: '请选择收取时间',
              trigger: 'change',
            },
          ],
        },
        carVisible: false,
        selectedCar: [],
        selectCar: [],
        brands: [],
        models: [],
        brands2: [],
        models2: [],
        selectBrand: [],
        selectModel: [],
        allCar: [],
        allModel: [],
        expands: [],
        addVisible: false,
        auditVisible: false,
        modifyAmountPortFlog: false, // 修改金额弹窗显示
        operationWidth: 0, // 表格数据
        sonOperationWidth: 0, // 子表格数据
        auditData: {
          table2: [],
        },
        rules2: {
          deduction: [
            {
              required: true,
              message: '请选择是否抵扣超出合同价',
              trigger: 'change',
            },
          ],
          invoice: [
            {
              required: true,
              message: '请选择是否暂缓开票',
              trigger: 'change',
            },
          ],
          invoicePrice: [
            {
              required: true,
              message: '请输入暂缓开票金额',
              trigger: 'blur',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择开票方式',
              trigger: 'change',
            },
          ],
          num: [
            {
              required: true,
              message: '请输入预计开票数量',
              trigger: 'blur',
            },
          ],
        },
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],
        numOption: [
          {
            label: 'D31835138135135',
            value: '1',
          },
          {
            label: 'D31835138135135',
            value: '2',
          },
          {
            label: 'D31835138135135',
            value: '3',
          },
          {
            label: 'D31835138135135',
            value: '4',
          },
        ],
        uploadUrl: '',
        imgIsUpload: false,

        invoiceTableData: [], // 发票数据
        addInvoiceVisible: false,
        isSalesList: 0, // 是否开具销售清单,
        basicId: 0,
        settlementNum: 0, // 未结算数量
        otherNum: 0, // 其他未结算数量
        uploadDis1: false, // 批量导入状态
        uploadUrl1: '', // 托运费用核对导入
        // 托运费用核对导入
        uploadData1: {
          mFile: '', // 托运费用核对导入
        },
        tableLoad1: false,
        detailTable1: [],
        detailTable1Loading: false,
        detailTable1Total: 0,
        detailTable1Size: 10,
        detailTable1Page: 1,
        detailTable2: [],
        detailTable2Loading: false,
        detailTable2Total: 0,
        detailTable2Size: 10,
        detailTable2Page: 1,
        settlement: 0,
        infoInvoice: [], // 详情 开票信息
        checkTableData: [], // 列表选中数据
      };
    },
    watch: {
      infoActiveName(val) {
        if (val === 'second') {
          this.getPageListSCFI();
        } else if (val === 'third') {
          this.getPageListSOCI();
        }
      },
    },
    filters: {
      workTypeFormat(value) {
        switch (value) {
          case 1:
            return '装车';
          case 2:
            return '卸车';
          case 3:
            return '过驳';
          case 4:
            return '转船';
        }
      },
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
        }
        return '';
      },
      settTypeFormat(value) {
        switch (value) {
          case 1:
            return '合同价';
          case 2:
            return '预结算价';
          case 3:
            return '合并价格';
        }
      },
      typeFormat(value) {
        switch (value) {
          case 1:
            return '委托商运费';
          case 2:
            return '委托商港口费';
          case 3:
            return '暂无';
          case 4:
            return '公路供应商托运费';
          case 5:
            return '水路供应商运费';
          case 6:
            return '港口供应商操作费';
          case 7:
            return '港口供应商燃油费';
          case 8:
            return '港口堆存费';
          case 9:
            return '提车费';
          case 13:
            return '港口库房委托商结算';
          case 14:
            return '港口库房供应商结算(库房)';
          case 15:
            return '港口库房供应商结算(港口)';
        }
      },
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待提交审核';
            case 1:
              return '审核对账单中';
            case 2:
              return '系统开票中';
            case 3:
              return '填写快递单号';
            case 4:
              return '已收款';
            case 5:
              return '发票寄送中';
            case 6:
              return '待财务审核';
            case 7:
              return '待提交开票';
            case 8:
              return '待打印发票';
            case 9:
              return '待财务核销';
            case 10:
              return '待复核确认';
            case 11:
              return '待财务确认';
            case 12:
              return '已完成';
            case -1:
              return '审核未通过';
            case -2:
              return '系统开票失败';
            case -10:
              return '已取消';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      /**
       *计算合计
       * @param tableData 表格数据
       * @param field 字段名
       * @returns {function(*, *): number}
       */
      sumCost(tableData, field) {
        return function (tableData, field) {
          let sum = 0;
          tableData
            ? tableData.forEach(item => {
                sum += parseFloat(item[field]);
              })
            : 0;
          return sum;
        };
      },
      settlementPriceCalculation() {
        return this.companyData.settlementPrice ? (this.companyData.settlementPrice - (this.companyData.settlementPrice * this.companyData.taxRate) / 100).toFixed(2) : 0;
      },
      otherFeeCalculation() {
        return this.companyData.otherPrice ? (this.companyData.otherPrice - (this.companyData.otherPrice * this.companyData.taxRate) / 100).toFixed(2) : 0;
      },
    },
    mounted() {
      //   this.accountList();
      this.uploadUrl1 = getImport('/platform/customer/account/checkAccountStatement');
    },
    methods: {
      async hongChong(row) {
        // console.log(row.id);
        this.$confirm('是否生成红冲对账单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const msg = this.$message({
            // showClose: true,
            iconClass: 'el-icon-loading',
            message: '生成红冲对账单中......'
          });
          const { status, message } = await hongChong({id: row.id});
          if (status !== 0) return this.$message.warning(message);
          msg.close()
          this.$message.success(message);
          this.searchBtn();
        })

      },
      editRemark(row) {
        this.$prompt('备注', '更改备注', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          inputValue: row.remark
        })
          .then(async ({ value }) => {
            const { status, message } = await remarkSubmit({
              id: row.id,
              remark: value
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.searchBtn();
          })
      },
      //获取发票号
      getInvoiceNo(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.invoiceNo).join(',');
        } else {
          return '';
        }
      },
      //获取发票时间
      getInvoiceCreateTime(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.createTime).join(',');
        } else {
          return '';
        }
      },
      //获取发票金额
      getInvoicePrice(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.taxPrice).join(',');
        } else {
          return '';
        }
      },
      async accountList() {
        const obj = {
          type: 25, // 供应商港口操作费费用结算
          settNo: this.numIpt,
          title: this.titleIpt,
          companyName: this.entrustIpt,
          consignor: this.consignor,
          startTime: this.timeIpt[0] ? this.timeIpt[0] : '',
          endTime: this.timeIpt[1] ? this.timeIpt[1] : '',
          settType: this.typeIpt,
          status: this.stateIpt,
          page: this.page,
          rows: this.size,
        };
        this.tableLoad = true;
        const res = await accountList(obj);
        this.tableLoad = false;
        if (res.status !== 0) {
          this.$message.error(res.message);
          return;
        }
        this.total = res.data.total;
        this.TableDatas = res.data.records;
        this.msg = res.msg;
        this.TableDatas.forEach(item => {
          item.child = [];
        });
        // 动态获取表格操作栏 宽度
        this.$nextTick(() => {
          this.operationWidth = this.tableWidth('fatherTable');
          console.log(this.operationWidth);
        });
      },
      compareDate(d1, d2) {
        return new Date(d1.replace(/-/g, '\/')) > new Date(d2.replace(/-/g, '\/'));
      },
      // 结束时间
      dateChange(val) {
        if (this.timeIpt[1] && this.timeIpt[0] && this.compareDate(this.timeIpt[0], this.timeIpt[1])) {
          if (val == this.timeIpt[1]) this.timeIpt[1] = '';
          if (val == this.timeIpt[0]) this.timeIpt[0] = '';
          this.$forceUpdate();
          this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      async _accountDetail(id) {
        const { status, data, message } = await accountDetail(id);
        if (status !== 0) return this.$message.warning(message);
        this.settlement = data.settType;
        if (data.auditRecordList) {
          this.stepData = [];
          // 审核信息数据
          data.auditRecordList.forEach(res => {
            const str = this.strFormat(res.status);
            const state = res.status == 3 ? 'failure' : res.status == 2 ? 'success' : '';
            this.stepData.push({
              title: res.auditorName + str,
              time: res.createTime,
              state,
              remark: res.opinion,
            });
          });
        }
        this.basicId = id;
        this.detailData = data;
      },
      // 主页面条数
      contractSizeChange(sizes) {
        this.size = sizes;
        this.accountList();
      },
      // 主页面页数
      contractCurrentChange(page) {
        this.page = page;
        this.accountList();
      },
      detailClose() {
        this.detailDialogVisible = false;
        this.infoActiveName = 'first';
      },
      dialogClose() {
        this.dialogVisible = false;
        this.tableData1 = [];
        this.tableData2 = [];
        this.activeName = 'first';
        this.accountList();
      },
      bjDate(date, date1) {
        var date = new Date(date);
        var date1 = new Date(date1);
        // 减小于0 date<date1
        return date.getTime() - date1.getTime() < 0;
      },
      carClick() {
        this.carVisible = true;
        this.selectCar = [...this.selectedCar];
        this.brands = [...this.brands2];
        this.models = [...this.models2];
      },
      selectRemove(item) {
        this.selectCar.splice(this.selectCar.indexOf(item), 1);
        if (this.brands.indexOf(item) !== -1) {
          this.brands.splice(this.brands.indexOf(item), 1);
        } else {
          this.models.splice(this.models.indexOf(item), 1);
        }
      },
      brandAdd(item) {
        if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！');
        let arr = [];
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === item.id) {
            arr = this.allCar[i].carModel;
            break;
          }
        }
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.selectCar.length; j++) {
            if (arr[i].id === this.selectCar[j].id) {
              this.selectCar.splice(j, 1);
              j--;
            }
          }
        }
        this.selectCar.push(item);
        this.brands.push(item);
      },
      modelAdd(item) {
        for (let i = 0; i < this.selectCar.length; i++) {
          if (this.selectCar[i].id === item.brandId) return this.$message.warning('上方已选择该品牌的全部车型！');
          if (this.selectCar[i].id === item.id) return this.$message.warning('已选择该车型！');
        }
        this.selectCar.push(item);
        this.models.push(item);
      },
      carAddClick() {
        this.carVisible = false;
        this.selectedCar = [...this.selectCar];
        this.brands2 = [...this.brands];
        this.models2 = [...this.models];
      },
      tableRowClassName({ row }) {
        if (row.price1 !== row.price2) return 'ui-warning-row';
        return '';
      },
      // 其他费用添加
      exportClick() {
        this.addVisible = true;
        // 调用子组件 分页查询
        this.$nextTick(() => {
          this.$refs.otherAdds._othercostGetAllByCompanyId();
        });
      },
      removeClick(index, val, type) {
        this.$confirm('确定要删除当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            if (type) {
              const { status, message } = await delOther({
                accountId: this.basicId,
                otherCostId: val.id,
              });
              if (status !== 0) return this.$message.warning(message);
              this.$message.success(message);
              await this.getOtherData();
            } else {
              const obj = {
                ...val,
                flag: 25,
                operateType: 'delete',
              };
              const res = await updateAndDeleteAmount(obj);
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              this.tableData1.splice(index, 1);
              const { data } = await accountDetail(this.basicId);
              this.companyData = data;
            }
          })
          .catch(() => {});
      },
      addTableClick(index, val) {
        if (val) {
          this.tableData2.push(this.tableData4[index]);
          this.tableData4.splice(index, 1);
        } else {
          this.tableData1.push(this.tableData3[index]);
          this.tableData3.splice(index, 1);
        }
      },
      changePriceClick(index, val) {
        const numReg = new RegExp(/^\d+(\.\d+)?$/);
        this.$prompt('请输入修改金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '请输入修改金额',
          inputValidator: value => {
            if (!value) return '请输入修改金额';
            if (!numReg.test(value)) return '请输入修改金额（仅非负数字）';
          },
          beforeClose: async (action, instance, done) => {
            if (action === 'cancel') {
              done();
              return;
            }
            val.taxPrice = instance.inputValue;
            let obj = {
              ...val,
              flag: 25,
              operateType: 'update',
            };
            const { status, message } = await updateAndDeleteAmount(obj);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            done();
          },
        });
      },

      /** *
       * 子组件添加其他费用触发  得到子组件勾选的数据
       *@param value 子组件传递勾选数据
       * */
      otherData(value) {
        this.tableData2 = value;
      },
      carClose() {
        this.carVisible = false;
      },
      brandClick(id) {
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === id) {
            this.selectModel = this.allCar[i].carModel.map(item => ({
              id: item.id,
              name: item.brand_name,
              brandId: item.brand_id,
            }));
            break;
          }
        }
      },
      deleteClick(id, reconciliator) {
        this.$confirm('确认删除当前对账单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await accountDelete(id, reconciliator);
            if (res.status === 0) {
              this.$message.success(res.message);
              this.searchBtn();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {});
      },
      collectionClick() {
        this.$confirm('确认要催收开票吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {})
          .catch(() => {});
      },
      hiddenClick(index, row) {
        this.TableDatas[index].tableShow = !this.TableDatas[index].tableShow;
        // 重构数组的remove方法
        Array.prototype.remove = function (val) {
          const index = this.indexOf(val);
          if (index > -1) {
            this.splice(index, 1);
          }
        };
        // 设置假数据
        this.TableDatas[index].child = [
          {
            entrust: 23,
            dealers: 435,
            planDate: 'sdf',
            state: '1',
          },
        ];
        // 动态获取 表格宽度
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.sonOperationWidth = this.tableWidth('childrenTable');
          });
        });

        if (this.expands.indexOf(row.id) < 0) {
          this.expands.push(row.id);
        } else {
          this.expands.remove(row.id);
        }
      },
      disableClick(id, reconciliator) {
        this.$confirm('确认要取消审核申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await cancelApplyFor(id, reconciliator);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {});
      },
      detailClick(id) {
        this.detailDialogVisible = true;
        this._accountDetail(id);
        this.getInfoInvoice(id);
      },
      async getInfoInvoice(id) {
        const { status, data, message } = await getInfoInvoice(id);
        if (status !== 0) return this.$message.warning(message);
        this.infoInvoice = data;
      },
      invoiceClick(id, reconciliator) {
        this.$refs.sendInvoiceRef.invoiceOpen(id, reconciliator);
      },
      /**
       * 核对对账单
       * @param id 表格id
       * @returns {Promise<ElMessageComponent>}
       */
      async changeClick(id) {
        const { status, data, message } = await accountDetail(id);
        // companyData
        if (status !== 0) return this.$message.error(message);
        this.basicId = id;
        this.companyId = data.companyId;
        this.dialogTitle = '核对对账单';
        this.dialogVisible = true;
        this.settlement = data.settType;
        this.companyData = data;
        await this.getOtherData();
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this.accountList();
      },
      resetBtn() {
        this.entrustIpt = '';
        this.titleIpt = '';
        this.numIpt = '';
        this.typeIpt = '';
        this.type = '';
        this.consignor = '';
        this.reconciliator = '';
        this.stateIpt = '';
        this.timeIpt = ['', ''];
      },
      auditClick(id, reconciliator) {
        this.basicId = id;
        this.reconciliator = reconciliator;
        this.$confirm('确认提交审核么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await submitAuditInvoice({
              id: this.basicId,
              isDetailedList: this.isSalesList,
              type: 25,
              reconciliator: this.reconciliator,
            });
            if (status !== 0) this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {});
      },
      auditClose() {
        this.auditVisible = false;
        this.$refs.ruleForm2.resetFields();
      },
      auditConfirmClick() {
        this.$refs.ruleForm2.validate(async valid => {
          if (valid) {
            if (this.auditData.deduction === 0) {
              if (this.auditData.table.length === 0) return this.$message.warning('抵扣费用表格不能为空！');
              for (let i = 0; i < this.auditData.table.length; i++) {
                if (!this.auditData.table[i].num || !this.auditData.table[i].price) return this.$message.warning('表格数据未填写完整！');
              }
            }
            if (this.auditData.type === 0) {
              if (this.auditData.table2.length === 0) return this.$message.warning('开票表格不能为空！');
              for (let i = 0; i < this.auditData.table2.length; i++) {
                if (!this.auditData.table2[i].price) return this.$message.warning('开票表格未填写完整！');
              }
            }
            let totalNum = 0;
            let num = 0;
            this.auditData.table2.forEach(item => {
              totalNum += Number(item.price);
            });
            if (this.auditData.invoice === 0) {
              num = Number(this.auditData.total) - Number(this.auditData.invoicePrice) - totalNum;
            } else {
              num = Number(this.auditData.total) - totalNum;
            }
            if (num < 0) return this.$message.warning('开票金额与暂缓开票金额之和不能大于开票总金额！');
            this.auditVisible = false;
          } else {
            return false;
          }
        });
      },
      numChange(index) {
        this.auditData.table[index].max = 123;
        this.auditData.table[index].price = 456;
      },
      addCl() {
        this.auditData.table.push({ num: '' });
      },
      addCl2() {
        this.auditData.table2.push({ price: '' });
      },
      numRemoveClick(index) {
        this.auditData.table.splice(index, 1);
      },
      invoiceRemoveClick(index) {
        this.auditData.table2.splice(index, 1);
      },
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        return isJPG && isLt10M;
      },
      uploadChange(file, fileList) {
        this.invoiceData.img = fileList;
        if (Object.keys(file).includes('response')) {
          if (file.response.status !== 0) {
            this.invoiceData.img.splice(this.invoiceData.img.indexOf(file), 1);
          }
        }
      },
      handleRemove(file, fileList) {
        this.invoiceData.img = fileList;
      },
      progress() {
        this.imgIsUpload = true;
      },
      success(res) {
        if (res.status !== 0) this.$message.error('该图片上传失败！');
        this.$message.success(res.message);
        this.imgIsUpload = false;
      },
      /**
       * 修改金额，确定
       * @param value 子组件插槽传递的数据
       */
      modifyconfirmClick(value) {
        this.$refs.modifyAmountPort.$refs.ruleForm.validate(valid => {
          if (valid) {
          } else {
          }
        });
      },
      // 修改金额，窗口关闭 ，清除数据
      modifyRemoveClick() {
        this.$refs.modifyAmountPort.$refs.ruleForm.resetFields();
        for (const modigyDataKey in this.$refs.modifyAmountPort.modigyData) {
          this.$refs.modifyAmountPort.modigyData[modigyDataKey] = '';
        }
        this.modifyAmountPortFlog = false;
      },
      // 要计算的 div class类
      tableWidth(divClass) {
        let operationWidth = 0;

        // this.$refs.operationWidth.querySelectorAll('button').forEach(item=>{
        //   console.log(item)
        //   this.operationWidth  +=item.clientWidth +15
        // })
        const divDom = $(`.${divClass}`);
        // 保存按钮最大数
        let max = $(divDom[0]).children().length;
        // 保存最大数所在div索引
        let divIndex = 0;
        divDom.each((index, item) => {
          if ($(item).children().length >= max) {
            // 如果大于就重新赋值
            max = $(item).children().length;
            divIndex = index;
          }
        });
        // 得到最大button个数 所在div 获取button元素
        $(divDom[divIndex])
          .children()
          .each((index, item) => {
            // console.log($(item).innerWidth())
            operationWidth += $(item).innerWidth() + 15;
          });
        console.log(operationWidth, divClass);
        return operationWidth;
      },
      beforeUpload(file) {
        this.tableLoad1 = true;
        this.uploadDis1 = true;
        if (file.name.split('.')[file.name.split('.').length - 1] == 'xls' || file.name.split('.')[file.name.split('.').length - 1] == 'xlsx') {
          this.uploadData1.mFile = file.name;
        } else {
          this.uploadDis1 = false;
          this.tableLoad1 = false;
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      uploadHttp(content) {
        let formData = new FormData();
        formData.append('file', content.file, content.file.name);
        console.log(content);
        console.log(formData);
        let that = this;
        this.$axios({
          method: 'post',
          url: content.action + '&id=' + that.basicId,
          timeout: 600 * 1000,
          data: formData,
          headers: { 'content-type': 'multipart/form-data' },
        })
          .then(res => {
            this.uploadDis1 = false;
            this.tableLoad1 = false;
            this.$alert(res.data.message, '提示', {
              confirmButtonText: '关闭',
              callback: async () => {
                this.tableData1 = res.data.data;
              },
            });
            // that._transportPlanCvPageList()
          })
          .catch(error => {
            if (error.response) {
              that.$message.error('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
              console.log('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
            } else if (error.request) {
              that.$message.error('配时文件上传失败，服务器端无响应');
              console.log('配时文件上传失败，服务器端无响应');
            } else {
              that.$message.error('配时文件上传失败，请求封装失败');
              console.log('配时文件上传失败，请求封装失败');
            }
            this.uploadDis = false;
            this.tableLoad1 = false;
          });
      },
      /**
       * 核对对账单 导入 成功函数
       * @param res 上传成功回调
       */
      planOnSuccess(res) {
        this.uploadDis1 = false;
        this.tableLoad1 = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        // this._transportPlanCvPageList()
        // this.TableDatas = res.data;
        this.$forceUpdate();
      },
      //模板下载
      download() {
        window.location.href = '/file/供应商操作费核对.xlsx';
      },
      async getPageListSCFI() {
        this.detailTable1Loading = true;
        const { status, message, data } = await getPageListSCFI({
          id: this.basicId,
          page: this.detailTable1Page,
          rows: this.detailTable1Size,
          type: 25,
        });
        this.detailTable1Loading = false;
        if (status !== 0) return this.$message.warning(message);
        this.detailTable1 = data ? data.records : [];
        this.detailTable1Total = data ? data.total : 0;
      },
      async getPageListSOCI() {
        this.detailTable2Loading = true;
        const { status, message, data } = await getPageListSOCI({
          id: this.basicId,
          page: this.detailTable2Page,
          rows: this.detailTable2Size,
        });
        this.detailTable2Loading = false;
        if (status !== 0) return this.$message.warning(message);
        this.detailTable2 = data ? data.records : [];
        this.detailTable2Total = data ? data.total : 0;
      },
      // 结算费用条数
      detailSizeChange(size) {
        this.detailTable1Size = size;
        this.getPageListSCFI();
      },
      // 结算费用页数
      detailCurrentChange(page) {
        this.detailTable1Page = page;
        this.getPageListSCFI();
      },
      // 其他结算费用条数
      detail2SizeChange(size) {
        this.detailTable2Size = size;
        this.getPageListSOCI();
      },
      // 其他结算费用页数
      detail2CurrentChange(page) {
        this.detailTable2Page = page;
        this.getPageListSOCI();
      },
      // 格式化审核信息状态
      strFormat(val) {
        let returnStr = '';
        switch (val) {
          case 0:
            returnStr = ' 重新发起';
            break;
          case 1:
            returnStr = ' 发起';
            break;
          case 2:
            returnStr = ' 同意';
            break;
          case 3:
            returnStr = ' 拒绝';
            break;
          case 4:
            returnStr = ' 取消审核';
            break;
          default:
            returnStr = '';
            break;
        }
        return returnStr;
      },
      async addClose() {
        this.addVisible = false;
      },
      async getOtherData() {
        this.addVisible = false;
        const { status, message, data } = await getPageListSOCI({
          id: this.basicId,
          page: 1,
          rows: 10,
        });
        if (status !== 0) return this.$message.warning(message);
        this.tableData2 = data ? data.records : [];
      },
      fillInInvoice(id, reconciliator, row) {
        this.$refs.invoiceInformation.openDialog(id, reconciliator);
        this.$refs.invoiceInformation.setTaxRate(row.taxRate);
      },
      cancelPush(id) {
        this.$confirm('确定要取消推送当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await cancellation({ id });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {});
      },
      async surePush() {
        this.pushLoading = true
        // let flag = true;
        // Object.keys(this.formPush).forEach((key) => {
        //   if (!this.formPush[key]) flag = false;
        // });
        // if (flag) {
          const params ={
            classbName: this.formPush.classbName,
            invoiceType: this.formPush.invoiceType,
            remarks: this.formPush.remarks,
            id:this.activeRow.id,
            reconciliator: this.activeRow.reconciliator,
          }
          const { status, message } = await dataPush(params);
          this.pushLoading = false
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.accountList();
          this.dialogFormVisiblePush = false
        // }

      },
      async dataPush(id, reconciliator,scope) {
        this.activeRow = scope.row;
        let productNumber = await paramCategoryPageList({
          value: '',
          status: '',
          rows: 9999,
          Page: 1,
          classaName: '',
          states: '',
          paramId: 'ac81ffe0197e4de19b7137dcb98f7784',
        });
        if (productNumber.status !== 0) return this.$message.warning(productNumber.message);

        this.productNumberOption = productNumber.data.records;

        let invoiceTypes = await paramCategoryPageList({
          value: '',
          status: '',
          rows: 9999,
          Page: 1,
          classaName: '',
          states: '',
          paramId: 'cf503167d28740f4b69aad91eb8dfd70',
        });
        if (invoiceTypes.status !== 0) return this.$message.warning(invoiceTypes.message);
        this.invoiceTypeOption = invoiceTypes.data.records;

        this.formPush.invoiceType = '';
        this.formPush.classbName = '';
        this.dialogFormVisiblePush = true;
        // this.$confirm('确定要推送当前数据吗？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning',
        // })
        //   .then(async () => {
        //     const { status, message } = await dataPush(id, reconciliator);
        //     if (status !== 0) return this.$message.warning(message);
        //     this.$message.success(message);
        //     await this.accountList();
        //   })
        //   .catch(() => {});
      },
      //作废
      async onClickVoid(row) {
        const { status, message, data } = await repeal({id: row.id});
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.accountList();
      },
      addContractPrice(id) {
        this.$refs.addContractPrice.openDialog(id, 25);
      },
      async exportDatas() {
        window.exportExcelAllFunc({
          type: 'get',
          url: '/customer/account/export',
          obj: {
            type: 25,
            settNo: this.numIpt,
            title: this.titleIpt,
            companyName: this.entrustIpt,
            startTime: this.timeIpt[0] ? this.timeIpt[0] : '',
            endTime: this.timeIpt[1] ? this.timeIpt[1] : '',
            settType: this.typeIpt,
            status: this.stateIpt,
            id: this.checkTableData.map(item => item.id).join(',')
          }
        });
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        const ids = [];
        this.checkTableData.forEach(item => {
          ids.push(item.id);
        });
        const exportParams = {
          type: 25,
          settNo: this.numIpt,
          title: this.titleIpt,
          companyName: this.entrustIpt,
          startTime: this.timeIpt[0] ? this.timeIpt[0] : '',
          endTime: this.timeIpt[1] ? this.timeIpt[1] : '',
          settType: this.typeIpt,
          status: this.stateIpt,
          ids: ids,
        };
        window.exportExcel(baseUrl + `/platform/customer/accountPrice/export?access_token=${token}`, exportParams, '供应商港口操作费补结算对账单结算数据');
        this.clearCheckTableData();
      },
      selectionDataChange(selection) {
        this.checkTableData = selection;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      clearCheckTableData() {
        this.$refs.listTable.clearSelection();
        this.checkTableData = [];
        this.accountList();
      },
      invoiceReceived(row) {
        this.$confirm('您确认已经收票么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await receiveInvoice(row.id, row.reconciliator);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {});
      },
      invoiceReturn(id, reconciliator) {
        this.$refs.statementReturnedRef.dialogOpen(id, reconciliator);
      },
      async titleChange(id, reconciliator) {
        this.$prompt('标题', '更改标题', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(async ({ value }) => {
            const { status, message } = await changeTitle({
              id,
              title: value,
              reconciliator,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消修改',
            });
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    /*background-color: #fff;*/
    .img-box {
      position: relative;
      width: 150px;
      height: 100px;

      img {
        width: 150px;
        height: 100px;
      }

      .tips {
        position: absolute;
        display: none;
      }

      &:hover .tips {
        display: block;
        position: absolute;
        //bottom:0;
        top: 0;
        left: 0;
        color: #fff;
        width: 146px;
        z-index: 10;
        height: 148px;
        background: #000;
        opacity: 0.6;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            //display: none;
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      ::v-deep {
        .el-table td,
        .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table .ui-warning-row {
            background-color: #fef0f0 !important;
          }

          .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
            background-color: #fef0f0 !important;
          }

          .el-table .ui-warning-row .cell {
            color: red;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;

          &Nav {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            span {
              color: rgba(51, 136, 255, 1);
              text-decoration: underline;
              margin-right: 10px;

              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .addCost {
      display: flex;
      flex-direction: column;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      &Nav {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      &Table {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            display: none;
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox:after {
            color: rgb(127, 127, 127);
            content: '全选';
            font-size: 12px;
            font-weight: 700;
            //margin-left: 2px;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox {
            margin-left: 8px;
          }

          .el-checkbox {
            margin-left: 16px;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      .imgUp {
        display: flex;
        flex-direction: column;

        .imgLength {
          display: flex;
          align-items: center;
          width: 90%;

          span {
            margin-left: auto;
            color: rgb(183, 183, 183);
            font-size: 16px;
          }
        }
      }

      &Table {
        margin-bottom: 25px;
        width: 100%;

        .tableAddBtnContainer {
          border: 1px solid #ebeef5;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #f59a23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .spanStyle {
    color: rgb(51, 136, 255);
    cursor: pointer;
    margin-left: 10px;
  }

  .btnTopBottom10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>
